module.exports = __webpack_public_path__ + "static/media/cover-image-kea.5b48d2f8.jpg";